// Generated automatically by nearley, version 2.20.1
// http://github.com/Hardmath123/nearley
function id(x) { return x[0]; }


import moo from 'moo'

// "The order of your rules matters. Earlier ones will take precedence." - for an JS object that sounds not very reliable.
// "Only rules from the current state can be matched. You need to copy your rule into all the states you want it to be matched in."
// From: https://github.com/no-context/moo#states

const P_EMBEDDED_REMARK = '\\(\\*[^]*?\\*\\)'
const P_TAIL_REMARK = '--[^\\r\\n]*\\r?\\n'
const P_ANY_REMARK_ANYWHERE = '(?:'+P_EMBEDDED_REMARK+'[ \t\r\n]*)?(?:'+P_TAIL_REMARK+'[ \t\r\n]*)?'
const rxOptWsAtEnd = new RegExp('\\s*'+P_ANY_REMARK_ANYWHERE+'\$', 'g')
function convStr(str) {
	return str.replace(rxOptWsAtEnd, '').slice(1, -1) // decoding (if needed) is done lazy
}

const P_SIMPLE_ID = '[a-zA-Z][a-zA-Z0-9_]*'

const P_REAL_VALUE = '[+-]?[0-9]+\\.[0-9]*(?:[eE][+-]?[0-9]+)?'
const P_INT_VALUE = '[+-]?[0-9]+'
//const P_STR_VALUE = "'(?:[^']| |'')*'"
const P_STR_VALUE = '\x27(?:[^\x27]| |\x27\x27)*\x27'
// string: {match: /"(?:\\["\\]|[^\n"\\])*"/, value: s => s.slice(1, -1)}
const P_ENCSTR_VALUE = '"(?:[0-9A-F]{8,8})*"'
// See: https://github.com/no-context/moo#value-vs-text
const P_BIN_VALUE = '"[0-3][0-9A-F]*"'

const sts = {}
sts['main'] = {}

sts['main']['WS'] = {match: /[ \t\r\n]+/, lineBreaks: true}
sts['main']['EMBEDDED_REMARK'] = {match: new RegExp(P_EMBEDDED_REMARK), lineBreaks: true}
sts['main']['TAIL_REMARK'] = {match: new RegExp(P_TAIL_REMARK), lineBreaks: true}

sts['main']['LB'] = '['
sts['main']['RB'] = ']'
sts['main']['LP'] = '('
sts['main']['RP'] = ')'
sts['main']['LC'] = '{'
sts['main']['RC'] = '}'
sts['main']['SNE'] = ':<>:'
sts['main']['SEQ'] = ':=:'
sts['main']['ASSIGN'] = ':='
sts['main']['COLON'] = ':'
sts['main']['DOT'] = '.'
sts['main']['SEMI'] = ';'
sts['main']['COMMA'] = ','
sts['main']['INDET'] = '?'
sts['main']['BACKSLASH'] = '\\'
sts['main']['DOUBLE_SOLID'] = '||'
sts['main']['SOLID'] = '|'
sts['main']['LESS_ASTERISK'] = '<*'
sts['main']['DOUBLE_ASTERISTK'] = '**'
sts['main']['ASTERISK'] = '*'
sts['main']['DIVIS'] = '/'
sts['main']['PLUS'] = '+'
sts['main']['MINUS'] = '-'
sts['main']['LE'] = '<='
sts['main']['NE'] = '<>'
sts['main']['LT'] = '<'
sts['main']['GE'] = '>='
sts['main']['GT'] = '>'
sts['main']['EQ'] = '='

sts['main']['REAL_LIT'] = {match: new RegExp(P_REAL_VALUE)}
sts['main']['INT'] = {match: new RegExp(P_INT_VALUE)}
sts['main']['STR'] = {match: new RegExp(P_STR_VALUE)}
sts['main']['ENCSTR'] = {match: new RegExp(P_ENCSTR_VALUE)}
sts['main']['BIN'] = {match: new RegExp(P_BIN_VALUE)}

const kwds = []
kwds.push('SCHEMA')
kwds.push('TYPEOF') // before TYPE
kwds.push('TYPE')
kwds.push('ENTITY')
kwds.push('RULE')
kwds.push('FUNCTION')
kwds.push('PROCEDURE')
kwds.push('SUBTYPE_CONSTRAINT') // before SUBTYPE
kwds.push('SUBTYPE')
kwds.push('SUPERTYPE')
kwds.push('GENERIC_ENTITY')
kwds.push('GENERIC')
kwds.push('RENAMED')
kwds.push('LOCAL')
kwds.push('WHERE')
kwds.push('DERIVE')
kwds.push('INVERSE')
kwds.push('ARRAY')
kwds.push('BAG')
kwds.push('LIST')
kwds.push('SET')
kwds.push('OPTIONAL')
kwds.push('UNIQUE')
kwds.push('AGGREGATE')
kwds.push('BINARY')
kwds.push('BOOLEAN')
kwds.push('INTEGER')
kwds.push('LOGICAL')
kwds.push('NUMBER')
kwds.push('REAL')
kwds.push('STRING')
kwds.push('FIXED')
kwds.push('REFERENCE')
kwds.push('CONSTANT')
kwds.push('FROM')
kwds.push('EXTENSIBLE')
kwds.push('ANDOR') // before AND
kwds.push('AND')
kwds.push('ONEOF')
kwds.push('END_SCHEMA') // before END
kwds.push('END_ENTITY') // before END
kwds.push('END_SUBTYPE_CONSTRAINT') // before END
kwds.push('END_TYPE') // before END
kwds.push('END_FUNCTION') // before END
kwds.push('END_PROCEDURE') // before END
kwds.push('END_RULE') // before END
kwds.push('END_LOCAL') // before END
kwds.push('END_CONSTANT') // before END
kwds.push('END_IF') // before END
kwds.push('END_ALIAS') // before END
kwds.push('END_REPEAT') // before END
kwds.push('END_CASE') // before END
kwds.push('END')
kwds.push('RETURN')
kwds.push('REMOVE')
kwds.push('INSERT')
kwds.push('SKIP')
kwds.push('ESCAPE')
kwds.push('CASE')
kwds.push('BEGIN')
kwds.push('ALIAS')
kwds.push('REPEAT')
kwds.push('IF')
kwds.push('ELSE')
kwds.push('ABSTRACT') // before ABS
kwds.push('ABS')
kwds.push('CONST_E')
kwds.push('PI')
kwds.push('SELF')
kwds.push('ACOS')
kwds.push('ASIN')
kwds.push('ATAN')
kwds.push('BLENGTH')
kwds.push('COS')
kwds.push('EXISTS')
kwds.push('EXP')
kwds.push('FORMAT') // before FOR
kwds.push('FOR')
kwds.push('HIBOUND')
kwds.push('HIINDEX')
kwds.push('LENGTH')
kwds.push('LOBOUND')
kwds.push('LOINDEX')
kwds.push('LOG2') // before LOG
kwds.push('LOG10') // before LOG
kwds.push('LOG')
kwds.push('NVL')
kwds.push('ODD')
kwds.push('ROLESOF')
kwds.push('SIN')
kwds.push('SIZEOF')
kwds.push('SQRT')
kwds.push('TAN')
kwds.push('USEDIN') // before USE
kwds.push('USE')
kwds.push('VALUE_IN') // before VALUE
kwds.push('VALUE_UNIQUE') // before VALUE
kwds.push('VALUE')
kwds.push('QUERY')
kwds.push('XOR')
kwds.push('TRUE')
kwds.push('FALSE')
kwds.push('UNKNOWN')
kwds.push('LIKE')
kwds.push('NOT')
kwds.push('DIV')
kwds.push('MOD')
kwds.push('OTHERWISE')
kwds.push('WHILE')
kwds.push('UNTIL')
kwds.push('THEN')
kwds.push('SELECT')
kwds.push('ENUMERATION')
kwds.push('BASED_ON')
kwds.push('WITH')
kwds.push('VAR')
kwds.push('TOTAL_OVER') // before TO
kwds.push('TO')
kwds.push('OR')
kwds.push('IN')
kwds.push('AS')
kwds.push('OF')
kwds.push('BY')

const kwm = Object.fromEntries(kwds.map(k => [k, k]))

sts['main']['SIMPLE_ID'] = {
	match: new RegExp(P_SIMPLE_ID),
	type: moo.keywords(kwm)
}

const lexer = moo.states(sts)

function pNfo(token) {
	return {
		//value: token.value,
		line: token.line,
		col: token.col,
		offset: token.offset,
		lineBreaks: token.lineBreaks
	}
}

function toRlo(dd) {
	const raw = dd.type.toLowerCase()
	switch(raw) {
		case 'le': return 'le'
		case 'ge': return 'ge'
		case 'ne': return 'ne'
		case 'eq': return 'eq'
		case 'seq': return 'se'
		case 'sne': return 'sn'
		case 'lt': return 'lt'
		case 'gt': return 'gt'
		case 'in': return 'in'
		case 'like': return 'lik'
	}
	throw new Error(`Invalid relational operator "${raw}" error.`)
}

function toAdo(d) {
	const raw = d[0][0].type.toLowerCase()
	switch(raw) {
		case 'plus': return 'pls'
		case 'minus': return 'min'
		case 'or': return 'oor'
		case 'xor': return 'xor'
	}
	throw new Error(`Invalid addition/subtraction (or/xor) operator "${raw}" error.`)
}

function toMpo(d) {
	const raw = d[0][0].type.toLowerCase()
	switch(raw) {
		case 'asterisk': return 'ast'
		case 'divis': return 'dvs'
		case 'div': return 'div'
		case 'mod': return 'mod'
		case 'and': return 'and'
		case 'double_solid': return 'll2'
	}
	throw new Error(`Invalid multiplication/division (and and double solid) operator "${raw}" error.`)
}

function toUno(d) {
	const raw = d[0][0].type.toLowerCase()
	switch(raw) {
		case 'plus': return 'psu'
		case 'minus': return 'msu'
		case 'not': return 'not'
	}
	throw new Error(`Invalid unary operator "${raw}" error.`)
}

function toBic(d) {
	const raw = d[0][0].value.toLowerCase()
	switch(raw) {
		case 'const_e': return 'eul'
		case 'pi': return 'pii'
		case 'self': return 'slf'
		case '?': return 'idt'
		case 'true': return 'tru'
		case 'false': return 'fls'
		case 'unknown': return 'ukn'
	}
	throw new Error(`Invalid built in constant "${raw}" error.`)
}

function toBif(d) {
	const raw = d[0][0].value.toLowerCase()
	switch(raw) {
		case 'abs': return 'abs'
		case 'acos': return 'acs'
		case 'asin': return 'asn'
		case 'atan': return 'atn'
		case 'blength': return 'bln'
		case 'cos': return 'cos'
		case 'exists': return 'xst'
		case 'exp': return 'exp'
		case 'format': return 'fmt'
		case 'hibound': return 'hbd'
		case 'hiindex': return 'hdx'
		case 'length': return 'len'
		case 'lobound': return 'lbd'
		case 'loindex': return 'ldx'
		case 'log': return 'lgn'
		case 'log2': return 'lg2'
		case 'log10': return 'lgx'
		case 'nvl': return 'nvl'
		case 'odd': return 'odd'
		case 'rolesof': return 'rlf'
		case 'sin': return 'sin'
		case 'sizeof': return 'szf'
		case 'sqrt': return 'qrt'
		case 'tan': return 'tan'
		case 'typeof': return 'tpf'
		case 'usedin': return 'usd'
		case 'value': return 'vlu'
		case 'value_in': return 'vln'
		case 'value_unique': return 'vlq'
	}
	throw new Error(`Invalid built in function "${raw}" error.`)
}

function toBip(d) {
	const raw = d[0][0].value.toLowerCase()
	switch(raw) {
		case 'insert': return 'ins'
		case 'remove': return 'rmv'
	}
	throw new Error(`Invalid built in procedure "${raw}" error.`)
}

function toSim(d) {
	const raw = d[0][0].value.toLowerCase()
	switch(raw) {
		case 'boolean': return 't_bol'
		case 'integer': return 't_int'
		case 'logical': return 't_lox'
		case 'number': return 't_nbr'
	}
	throw new Error(`Invalid simple data type "${raw}" error.`)
}

function toReal(token) {
	return withWidthSpec(token, 't_rea', true)
}

function toStr(token) {
	return withWidthSpec(token, 't_str')
}

function toBin(token) {
	return withWidthSpec(token, 't_bin')
}

function withWidthSpec(token, typeStr, primIsFrom=false) {
	if (token[1]) { // cannot check token.length since token[1] is null
		let primFld = 'to'
		let scndFld = 'fr'
		if (primIsFrom) {
			primFld = 'fr'
			scndFld = 'to'
		}
		// See width_spec on how token[1] looks like.
		if ('width' in token[1]) {
			// console.log(token[1].width)
			if (token[1].width.t == 'width_ref') {
				token[1].t = 'bds'
				const fixed = token[1].fixed
				const varRef = token[1].width.id
				token[1][primFld] = {t:'a_sxp_trms', s:[{t:'a_trm_ftrs', s:[{t:'ftr', arg0:{t:'any_ref', id:varRef}, qals0:null, arg1:null, qals1:null, p:pNfo(token[1].p) }]}]}
				if (fixed) {
					token[1][scndFld] = token[1][primFld]
				} else {
					token[1][scndFld] = null
				}
				delete token[1].width
				delete token[1].fixed
			} else {
				token[1].t = 'bds'
				const fixed = token[1].fixed
				const parsed = parseInt(token[1].width.value)
				if (!isNaN(parsed) && 0 < parsed) {
					token[1][primFld] = {t:'a_sxp_trms', s:[{t:'a_trm_ftrs', s:[{t:'ftr', arg0:{t:'int', val:parsed}, qals0:null, arg1:null, qals1:null}]}]}
					if (fixed) {
						token[1][scndFld] = token[1][primFld]
					} else {
						token[1][scndFld] = null
					}
					delete token[1].width
					delete token[1].fixed
				}
			}
		}
		// TODO what about p:pNfo?
		return {t:typeStr, bds:token[1]}
	} else {
		return {t:typeStr, bds:null}
	}
}

function toArr(token, tName) {
	if (token && 0 < token.length) {
		return {t:tName, s:token}
	} else {
		return null
	}
}

function toBds(token) { // Also used for t:'itr'.
	// Originally this was jsut a undefined check, but then it was not
	// achieved by parser rules to get a simple INDET representation
	// when the token is just a question_mark. So simplifyBndExpr(..) .
	if (token) {
		token.fr = simplifyBndExpr(token.fr)
		token.to = simplifyBndExpr(token.to)
		return token
	}
	return null
}

function simplifyBndExpr(expr) {
	if (expr
		&& expr.t == 'a_sxp_trms'
		&& expr.s.length == 1 && expr.s[0]
		&& expr.s[0].t == 'a_trm_ftrs'
		&& expr.s[0].s.length == 1 && expr.s[0].s[0]
		&& expr.s[0].s[0].t == 'ftr'
		&& expr.s[0].s[0].arg1 == null
		&& expr.s[0].s[0].arg0.t == 'bic'
		&& expr.s[0].s[0].arg0.id == 'idt'
	) {
		return null
	}
	return expr
}

function toInverse(d) {
	const res = {
		t:'inv',
		id:d[0],
		agrTyp:null,
		agrBds:null,
		nttRef:toNttRef(d[3]),
		invRef:{t:'any_ref', id:d[5].value, p:pNfo(d[5])},
		p:pNfo(d[0])
	}
	if (d[2]) {
		res.agrTyp = d[2][0][0].value.toLowerCase()
		if (d[2][1]) {
			res.agrBds = toBds(d[2][1])
		} else {
			res.agrBds = {
				t:'bds',
				fr:{t:'a_sxp_trms', s:[{t:'a_trm_ftrs', s:[{t:'ftr',
					arg0:{t:'int',val:0},
					qals0:null,
					arg1:null,qals1:null
				}]}]},
				to:null
			}
		}
	}
	return res
}

function toEotRef(token) { // used for entity_ref | type_ref
	if (token.value) {
		return {t:'any_ref', id:token.value, p:pNfo(token)}
	} else {
		return null
	}
}

function toNttRef(token) { // used for entity_ref only
	if (token && token.value) {
		return {t:'ntt_ref', id:token.value, p:pNfo(token)}
	} else {
		return null
	}
}

// Make remarks (e.g. EMBEDDED_REMARK) not to be passed to the parser.
lexer.next = (next => () => {
    let tok
    while ((tok = next.call(lexer)) && (
						tok.type === 'WS'
				||	tok.type === 'EMBEDDED_REMARK'
				||	tok.type === 'TAIL_REMARK'
			)) {}
		//if (tok) { // Out the result from the lexer.
		//	console.log(tok.type, tok.value, lexer.stack, lexer.state)
		//}
		if (tok && tok.type === 'SIMPLE_ID') {
			// Check if it is not a (partially) lower case keyword.
			const tType = kwm[tok.value.toUpperCase()]
			if (tType) {
				tok.type = tType
			}
		}
    return tok
})(lexer.next)
let Lexer = lexer;
let ParserRules = [
    {"name": "main$ebnf$1", "symbols": [(lexer.has("WS") ? {type: "WS"} : WS)], "postprocess": id},
    {"name": "main$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["main$ebnf$1", "syntax"], "postprocess": d => d[1]},
    {"name": "type_decl$ebnf$1", "symbols": ["where_clause"], "postprocess": id},
    {"name": "type_decl$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "type_decl", "symbols": [(lexer.has("TYPE") ? {type: "TYPE"} : TYPE), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("EQ") ? {type: "EQ"} : EQ), "underlying_type", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "type_decl$ebnf$1", (lexer.has("END_TYPE") ? {type: "END_TYPE"} : END_TYPE), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'typ', id:d[1].value, spc:d[3], whrs:toArr(d[5],'a_typ_whrs'), p:pNfo(d[0])})},
    {"name": "underlying_type$subexpression$1", "symbols": ["enumeration_type"]},
    {"name": "underlying_type$subexpression$1", "symbols": ["select_type"]},
    {"name": "underlying_type$subexpression$1", "symbols": ["general_aggregation_types"]},
    {"name": "underlying_type$subexpression$1", "symbols": ["simple_types"]},
    {"name": "underlying_type$subexpression$1", "symbols": ["named_types"]},
    {"name": "underlying_type", "symbols": ["underlying_type$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "enumeration_type$ebnf$1", "symbols": [(lexer.has("EXTENSIBLE") ? {type: "EXTENSIBLE"} : EXTENSIBLE)], "postprocess": id},
    {"name": "enumeration_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "enumeration_type", "symbols": ["enumeration_type$ebnf$1", (lexer.has("ENUMERATION") ? {type: "ENUMERATION"} : ENUMERATION), (lexer.has("OF") ? {type: "OF"} : OF), (lexer.has("LP") ? {type: "LP"} : LP), "enum_id_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'enm', xtd:(!!d[0]), vals:toArr(d[4],'a_enm_vals'), p:pNfo(d[1]) })},
    {"name": "enumeration_type$ebnf$2", "symbols": [(lexer.has("EXTENSIBLE") ? {type: "EXTENSIBLE"} : EXTENSIBLE)], "postprocess": id},
    {"name": "enumeration_type$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "enumeration_type", "symbols": ["enumeration_type$ebnf$2", (lexer.has("ENUMERATION") ? {type: "ENUMERATION"} : ENUMERATION), (lexer.has("BASED_ON") ? {type: "BASED_ON"} : BASED_ON), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("WITH") ? {type: "WITH"} : WITH), (lexer.has("LP") ? {type: "LP"} : LP), "enum_id_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'enm_xtdd', xtd:(!!d[0]), ref:{t:'typ_ref', id:d[3].value}, vals:toArr(d[6],'a_enm_vals'), p:pNfo(d[1]) })},
    {"name": "enum_id_list$ebnf$1", "symbols": []},
    {"name": "enum_id_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "enum_value"]},
    {"name": "enum_id_list$ebnf$1", "symbols": ["enum_id_list$ebnf$1", "enum_id_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "enum_id_list", "symbols": ["enum_value", "enum_id_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "enum_value", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'evl', id:d[0].value, p:pNfo(d[0])})},
    {"name": "select_type$ebnf$1$subexpression$1$ebnf$1", "symbols": [(lexer.has("GENERIC_ENTITY") ? {type: "GENERIC_ENTITY"} : GENERIC_ENTITY)], "postprocess": id},
    {"name": "select_type$ebnf$1$subexpression$1$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "select_type$ebnf$1$subexpression$1", "symbols": [(lexer.has("EXTENSIBLE") ? {type: "EXTENSIBLE"} : EXTENSIBLE), "select_type$ebnf$1$subexpression$1$ebnf$1"]},
    {"name": "select_type$ebnf$1", "symbols": ["select_type$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "select_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "select_type", "symbols": ["select_type$ebnf$1", (lexer.has("SELECT") ? {type: "SELECT"} : SELECT), (lexer.has("LP") ? {type: "LP"} : LP), "select_ref_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'slc', xtd:!!(d[0]&&!!d[0][0]), refs:toArr(d[3],'a_slc_refs'), nttOnly:!!(d[0]&&!!d[0][1]), p:pNfo(d[1])})},
    {"name": "select_type$ebnf$2$subexpression$1$ebnf$1", "symbols": [(lexer.has("GENERIC_ENTITY") ? {type: "GENERIC_ENTITY"} : GENERIC_ENTITY)], "postprocess": id},
    {"name": "select_type$ebnf$2$subexpression$1$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "select_type$ebnf$2$subexpression$1", "symbols": [(lexer.has("EXTENSIBLE") ? {type: "EXTENSIBLE"} : EXTENSIBLE), "select_type$ebnf$2$subexpression$1$ebnf$1"]},
    {"name": "select_type$ebnf$2", "symbols": ["select_type$ebnf$2$subexpression$1"], "postprocess": id},
    {"name": "select_type$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "select_type", "symbols": ["select_type$ebnf$2", (lexer.has("SELECT") ? {type: "SELECT"} : SELECT), (lexer.has("BASED_ON") ? {type: "BASED_ON"} : BASED_ON), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("WITH") ? {type: "WITH"} : WITH), (lexer.has("LP") ? {type: "LP"} : LP), "select_ref_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'slc_xtdd', xtd:!!(d[0]&&!!d[0][0]), ref:{t:'typ_ref', id:d[3].value}, refs:toArr(d[6],'a_slc_refs'), nttOnly:!!(d[0]&&!!d[0][1]), p:pNfo(d[1])})},
    {"name": "select_ref_list$ebnf$1", "symbols": []},
    {"name": "select_ref_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "named_types"]},
    {"name": "select_ref_list$ebnf$1", "symbols": ["select_ref_list$ebnf$1", "select_ref_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "select_ref_list", "symbols": ["named_types", "select_ref_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "function_decl$ebnf$1", "symbols": ["formal_params"], "postprocess": id},
    {"name": "function_decl$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "function_decl$ebnf$2", "symbols": []},
    {"name": "function_decl$ebnf$2", "symbols": ["function_decl$ebnf$2", "declaration"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "function_decl$ebnf$3", "symbols": ["constant_decl"], "postprocess": id},
    {"name": "function_decl$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "function_decl$ebnf$4", "symbols": ["local_decl"], "postprocess": id},
    {"name": "function_decl$ebnf$4", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "function_decl$ebnf$5", "symbols": ["stmt"]},
    {"name": "function_decl$ebnf$5", "symbols": ["function_decl$ebnf$5", "stmt"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "function_decl", "symbols": [(lexer.has("FUNCTION") ? {type: "FUNCTION"} : FUNCTION), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), "function_decl$ebnf$1", (lexer.has("COLON") ? {type: "COLON"} : COLON), "parameter_type", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "function_decl$ebnf$2", "function_decl$ebnf$3", "function_decl$ebnf$4", "function_decl$ebnf$5", (lexer.has("END_FUNCTION") ? {type: "END_FUNCTION"} : END_FUNCTION), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'fun', id:d[1].value,
        	prms:toArr(d[2],'a_fun_prms'),
        	res:d[4],
        	ctts:toArr(d[6],'a_fun_ctts'),
        	csts:toArr(d[7],'a_fun_csts'),
        	lcls:toArr(d[8],'a_fun_lcls'),
        	stms:toArr(d[9],'a_fun_stms'), p:pNfo(d[0])
        }) },
    {"name": "procedure_decl$ebnf$1", "symbols": ["p_formal_params"], "postprocess": id},
    {"name": "procedure_decl$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "procedure_decl$ebnf$2", "symbols": []},
    {"name": "procedure_decl$ebnf$2", "symbols": ["procedure_decl$ebnf$2", "declaration"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "procedure_decl$ebnf$3", "symbols": ["constant_decl"], "postprocess": id},
    {"name": "procedure_decl$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "procedure_decl$ebnf$4", "symbols": ["local_decl"], "postprocess": id},
    {"name": "procedure_decl$ebnf$4", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "procedure_decl$ebnf$5", "symbols": []},
    {"name": "procedure_decl$ebnf$5", "symbols": ["procedure_decl$ebnf$5", "stmt"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "procedure_decl", "symbols": [(lexer.has("PROCEDURE") ? {type: "PROCEDURE"} : PROCEDURE), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), "procedure_decl$ebnf$1", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "procedure_decl$ebnf$2", "procedure_decl$ebnf$3", "procedure_decl$ebnf$4", "procedure_decl$ebnf$5", (lexer.has("END_PROCEDURE") ? {type: "END_PROCEDURE"} : END_PROCEDURE), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'prc', id:d[1].value,
        	prms:toArr(d[2],'a_prc_prms'),
        	ctts:toArr(d[4],'a_prc_ctts'),
        	csts:toArr(d[5],'a_prc_csts'),
        	lcls:toArr(d[6],'a_prc_lcls'),
        	stms:toArr(d[7],'a_prc_stms'), p:pNfo(d[0])
        }) },
    {"name": "rule_decl$ebnf$1", "symbols": []},
    {"name": "rule_decl$ebnf$1", "symbols": ["rule_decl$ebnf$1", "declaration"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "rule_decl$ebnf$2", "symbols": ["constant_decl"], "postprocess": id},
    {"name": "rule_decl$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "rule_decl$ebnf$3", "symbols": ["local_decl"], "postprocess": id},
    {"name": "rule_decl$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "rule_decl$ebnf$4", "symbols": []},
    {"name": "rule_decl$ebnf$4", "symbols": ["rule_decl$ebnf$4", "stmt"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "rule_decl", "symbols": [(lexer.has("RULE") ? {type: "RULE"} : RULE), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("FOR") ? {type: "FOR"} : FOR), (lexer.has("LP") ? {type: "LP"} : LP), "ntt_ref_list", (lexer.has("RP") ? {type: "RP"} : RP), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "rule_decl$ebnf$1", "rule_decl$ebnf$2", "rule_decl$ebnf$3", "rule_decl$ebnf$4", "where_clause", (lexer.has("END_RULE") ? {type: "END_RULE"} : END_RULE), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'rul', id:d[1].value,
        	nttRefs:toArr(d[4],'a_rul_refs'),
        	ctts:toArr(d[7],'a_rul_ctts'),
        	csts:toArr(d[8],'a_rul_csts'),
        	lcls:toArr(d[9],'a_rul_lcls'),
        	stms:toArr(d[10],'a_rul_stms'),
        	whrs:toArr(d[11],'a_rul_whrs'), p:pNfo(d[0])
        }) },
    {"name": "ntt_ref_list$ebnf$1", "symbols": []},
    {"name": "ntt_ref_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "ntt_ref"]},
    {"name": "ntt_ref_list$ebnf$1", "symbols": ["ntt_ref_list$ebnf$1", "ntt_ref_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "ntt_ref_list", "symbols": ["ntt_ref", "ntt_ref_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "ntt_ref", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'ntt_ref', id:d[0].value, p:pNfo(d[0])})},
    {"name": "declaration$subexpression$1", "symbols": ["type_decl"]},
    {"name": "declaration$subexpression$1", "symbols": ["entity_decl"]},
    {"name": "declaration$subexpression$1", "symbols": ["subtype_constraint_decl"]},
    {"name": "declaration$subexpression$1", "symbols": ["function_decl"]},
    {"name": "declaration$subexpression$1", "symbols": ["procedure_decl"]},
    {"name": "declaration", "symbols": ["declaration$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "local_decl$ebnf$1", "symbols": ["local_variables"]},
    {"name": "local_decl$ebnf$1", "symbols": ["local_decl$ebnf$1", "local_variables"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "local_decl", "symbols": [(lexer.has("LOCAL") ? {type: "LOCAL"} : LOCAL), "local_decl$ebnf$1", (lexer.has("END_LOCAL") ? {type: "END_LOCAL"} : END_LOCAL), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => d[1]},
    {"name": "local_variables$ebnf$1$subexpression$1", "symbols": [(lexer.has("ASSIGN") ? {type: "ASSIGN"} : ASSIGN), "expression"]},
    {"name": "local_variables$ebnf$1", "symbols": ["local_variables$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "local_variables$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "local_variables", "symbols": ["variable_id_list", (lexer.has("COLON") ? {type: "COLON"} : COLON), "parameter_type", "local_variables$ebnf$1", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'lcl_dcl', ids:toArr(d[0],'a_lcl_ids'), typ:d[2], xpr:(d[3]?d[3][1]:null), p:pNfo(d[0])})},
    {"name": "variable_id_list$ebnf$1", "symbols": []},
    {"name": "variable_id_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "variable_id"]},
    {"name": "variable_id_list$ebnf$1", "symbols": ["variable_id_list$ebnf$1", "variable_id_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "variable_id_list", "symbols": ["variable_id", "variable_id_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "variable_id", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'lcl', id:d[0].value, p:pNfo(d[0])})},
    {"name": "parameter_type$subexpression$1", "symbols": ["generalized_types"]},
    {"name": "parameter_type$subexpression$1", "symbols": ["simple_types"]},
    {"name": "parameter_type$subexpression$1", "symbols": ["named_types"]},
    {"name": "parameter_type", "symbols": ["parameter_type$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "generalized_types$subexpression$1", "symbols": ["aggregate_type"]},
    {"name": "generalized_types$subexpression$1", "symbols": ["general_aggregation_types"]},
    {"name": "generalized_types$subexpression$1", "symbols": ["generic_entity_type"]},
    {"name": "generalized_types$subexpression$1", "symbols": ["generic_type"]},
    {"name": "generalized_types", "symbols": ["generalized_types$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "general_aggregation_types$subexpression$1", "symbols": ["general_array_type"]},
    {"name": "general_aggregation_types$subexpression$1", "symbols": ["general_bag_type"]},
    {"name": "general_aggregation_types$subexpression$1", "symbols": ["general_list_type"]},
    {"name": "general_aggregation_types$subexpression$1", "symbols": ["general_set_type"]},
    {"name": "general_aggregation_types", "symbols": ["general_aggregation_types$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "general_array_type$ebnf$1", "symbols": ["bound_spec"], "postprocess": id},
    {"name": "general_array_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "general_array_type$ebnf$2", "symbols": [(lexer.has("OPTIONAL") ? {type: "OPTIONAL"} : OPTIONAL)], "postprocess": id},
    {"name": "general_array_type$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "general_array_type$ebnf$3", "symbols": [(lexer.has("UNIQUE") ? {type: "UNIQUE"} : UNIQUE)], "postprocess": id},
    {"name": "general_array_type$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "general_array_type", "symbols": [(lexer.has("ARRAY") ? {type: "ARRAY"} : ARRAY), "general_array_type$ebnf$1", (lexer.has("OF") ? {type: "OF"} : OF), "general_array_type$ebnf$2", "general_array_type$ebnf$3", "parameter_type"], "postprocess": d => ({t:'arr', bds:toBds(d[1]), opt:(!!d[3]), unq:(!!d[4]), spc:d[5], p:pNfo(d[0])})},
    {"name": "general_bag_type$ebnf$1", "symbols": ["bound_spec"], "postprocess": id},
    {"name": "general_bag_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "general_bag_type", "symbols": [(lexer.has("BAG") ? {type: "BAG"} : BAG), "general_bag_type$ebnf$1", (lexer.has("OF") ? {type: "OF"} : OF), "parameter_type"], "postprocess": d => ({t:'bag', bds:toBds(d[1]), spc:d[3], p:pNfo(d[0])})},
    {"name": "general_list_type$ebnf$1", "symbols": ["bound_spec"], "postprocess": id},
    {"name": "general_list_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "general_list_type$ebnf$2", "symbols": [(lexer.has("UNIQUE") ? {type: "UNIQUE"} : UNIQUE)], "postprocess": id},
    {"name": "general_list_type$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "general_list_type", "symbols": [(lexer.has("LIST") ? {type: "LIST"} : LIST), "general_list_type$ebnf$1", (lexer.has("OF") ? {type: "OF"} : OF), "general_list_type$ebnf$2", "parameter_type"], "postprocess": d => ({t:'lst', bds:toBds(d[1]), unq:(!!d[3]), spc:d[4], p:pNfo(d[0])})},
    {"name": "general_set_type$ebnf$1", "symbols": ["bound_spec"], "postprocess": id},
    {"name": "general_set_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "general_set_type", "symbols": [(lexer.has("SET") ? {type: "SET"} : SET), "general_set_type$ebnf$1", (lexer.has("OF") ? {type: "OF"} : OF), "parameter_type"], "postprocess": d => ({t:'set', bds:toBds(d[1]), spc:d[3], p:pNfo(d[0])})},
    {"name": "bound_spec", "symbols": [(lexer.has("LB") ? {type: "LB"} : LB), "simple_expression", (lexer.has("COLON") ? {type: "COLON"} : COLON), "simple_expression", (lexer.has("RB") ? {type: "RB"} : RB)], "postprocess": d => ({t:'bds', fr:d[1], to:d[3], p:pNfo(d[0])})},
    {"name": "generic_type", "symbols": [(lexer.has("GENERIC") ? {type: "GENERIC"} : GENERIC)], "postprocess": d => ({t:'gen', p:pNfo(d[0])})},
    {"name": "generic_type", "symbols": [(lexer.has("GENERIC") ? {type: "GENERIC"} : GENERIC), (lexer.has("COLON") ? {type: "COLON"} : COLON), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'gen_lbld', lbl:d[2].value, p:pNfo(d[0])})},
    {"name": "generic_entity_type", "symbols": [(lexer.has("GENERIC_ENTITY") ? {type: "GENERIC_ENTITY"} : GENERIC_ENTITY)], "postprocess": d => ({t:'gtt', p:pNfo(d[0])})},
    {"name": "generic_entity_type", "symbols": [(lexer.has("GENERIC_ENTITY") ? {type: "GENERIC_ENTITY"} : GENERIC_ENTITY), (lexer.has("COLON") ? {type: "COLON"} : COLON), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'gtt_lbld', lbl:d[2].value, p:pNfo(d[0])})},
    {"name": "aggregate_type", "symbols": [(lexer.has("AGGREGATE") ? {type: "AGGREGATE"} : AGGREGATE), (lexer.has("OF") ? {type: "OF"} : OF), "parameter_type"], "postprocess": d => ({t:'agt', spc:d[2], p:pNfo(d[0])})},
    {"name": "aggregate_type", "symbols": [(lexer.has("AGGREGATE") ? {type: "AGGREGATE"} : AGGREGATE), (lexer.has("COLON") ? {type: "COLON"} : COLON), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("OF") ? {type: "OF"} : OF), "parameter_type"], "postprocess": d => ({t:'agt_lbld', lbl:d[2].value, spc:d[4], p:pNfo(d[0])})},
    {"name": "simple_types$subexpression$1", "symbols": [(lexer.has("BOOLEAN") ? {type: "BOOLEAN"} : BOOLEAN)]},
    {"name": "simple_types$subexpression$1", "symbols": [(lexer.has("INTEGER") ? {type: "INTEGER"} : INTEGER)]},
    {"name": "simple_types$subexpression$1", "symbols": [(lexer.has("LOGICAL") ? {type: "LOGICAL"} : LOGICAL)]},
    {"name": "simple_types$subexpression$1", "symbols": [(lexer.has("NUMBER") ? {type: "NUMBER"} : NUMBER)]},
    {"name": "simple_types", "symbols": ["simple_types$subexpression$1"], "postprocess": d => ({t:toSim(d)})},
    {"name": "simple_types", "symbols": ["real_type"], "postprocess": d => (toReal(d[0]))},
    {"name": "simple_types", "symbols": ["string_type"], "postprocess": d => (toStr(d[0]))},
    {"name": "simple_types", "symbols": ["binary_type"], "postprocess": d => (toBin(d[0]))},
    {"name": "named_types", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => toEotRef(d[0])},
    {"name": "real_type$ebnf$1", "symbols": ["precision_spec"], "postprocess": id},
    {"name": "real_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "real_type", "symbols": [(lexer.has("REAL") ? {type: "REAL"} : REAL), "real_type$ebnf$1"]},
    {"name": "precision_spec", "symbols": [(lexer.has("LP") ? {type: "LP"} : LP), "one_to_bounds_expr", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({width:d[1], p:pNfo(d[0])})},
    {"name": "string_type$ebnf$1", "symbols": ["width_spec"], "postprocess": id},
    {"name": "string_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "string_type", "symbols": [(lexer.has("STRING") ? {type: "STRING"} : STRING), "string_type$ebnf$1"]},
    {"name": "binary_type$ebnf$1", "symbols": ["width_spec"], "postprocess": id},
    {"name": "binary_type$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "binary_type", "symbols": [(lexer.has("BINARY") ? {type: "BINARY"} : BINARY), "binary_type$ebnf$1"]},
    {"name": "width_spec$ebnf$1", "symbols": [(lexer.has("FIXED") ? {type: "FIXED"} : FIXED)], "postprocess": id},
    {"name": "width_spec$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "width_spec", "symbols": [(lexer.has("LP") ? {type: "LP"} : LP), "one_to_bounds_expr", (lexer.has("RP") ? {type: "RP"} : RP), "width_spec$ebnf$1"], "postprocess": d => ({width:d[1], fixed:(!!d[3]), p:pNfo(d[0])})},
    {"name": "one_to_bounds_expr", "symbols": [(lexer.has("INT") ? {type: "INT"} : INT)], "postprocess": d => d[0]},
    {"name": "one_to_bounds_expr", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'width_ref', id:d[0].value, p:pNfo(d[0])})},
    {"name": "explicit_attr$ebnf$1", "symbols": [(lexer.has("OPTIONAL") ? {type: "OPTIONAL"} : OPTIONAL)], "postprocess": id},
    {"name": "explicit_attr$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "explicit_attr", "symbols": ["attr_list", (lexer.has("COLON") ? {type: "COLON"} : COLON), "explicit_attr$ebnf$1", "parameter_type", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'atr_dcl', ids:toArr(d[0],'a_atr_ids'), opt:(!!d[2]), typ:d[3], p:pNfo(d[0])})},
    {"name": "derived_attr", "symbols": ["attr", (lexer.has("COLON") ? {type: "COLON"} : COLON), "parameter_type", (lexer.has("ASSIGN") ? {type: "ASSIGN"} : ASSIGN), "expression", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'drv', id:d[0], typ:d[2], xpr:d[4], p:pNfo(d[0])})},
    {"name": "inverse_attr$ebnf$1$subexpression$1$subexpression$1", "symbols": [(lexer.has("SET") ? {type: "SET"} : SET)]},
    {"name": "inverse_attr$ebnf$1$subexpression$1$subexpression$1", "symbols": [(lexer.has("BAG") ? {type: "BAG"} : BAG)]},
    {"name": "inverse_attr$ebnf$1$subexpression$1$ebnf$1", "symbols": ["bound_spec"], "postprocess": id},
    {"name": "inverse_attr$ebnf$1$subexpression$1$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "inverse_attr$ebnf$1$subexpression$1", "symbols": ["inverse_attr$ebnf$1$subexpression$1$subexpression$1", "inverse_attr$ebnf$1$subexpression$1$ebnf$1", (lexer.has("OF") ? {type: "OF"} : OF)]},
    {"name": "inverse_attr$ebnf$1", "symbols": ["inverse_attr$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "inverse_attr$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "inverse_attr", "symbols": ["attr", (lexer.has("COLON") ? {type: "COLON"} : COLON), "inverse_attr$ebnf$1", (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("FOR") ? {type: "FOR"} : FOR), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => toInverse(d)},
    {"name": "attr_list$ebnf$1", "symbols": []},
    {"name": "attr_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "attr"]},
    {"name": "attr_list$ebnf$1", "symbols": ["attr_list$ebnf$1", "attr_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "attr_list", "symbols": ["attr", "attr_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "attr", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'atr', id:d[0].value, p:pNfo(d[0])})},
    {"name": "attr", "symbols": ["qualified_attribute_renamed"], "postprocess": d => d[0]},
    {"name": "attr", "symbols": ["qualified_attribute"], "postprocess": d => d[0]},
    {"name": "qualified_attribute$ebnf$1$subexpression$1", "symbols": [(lexer.has("BACKSLASH") ? {type: "BACKSLASH"} : BACKSLASH), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)]},
    {"name": "qualified_attribute$ebnf$1", "symbols": ["qualified_attribute$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "qualified_attribute$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "qualified_attribute", "symbols": [(lexer.has("SELF") ? {type: "SELF"} : SELF), "qualified_attribute$ebnf$1", (lexer.has("DOT") ? {type: "DOT"} : DOT), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'qal_atr', id:d[3].value, nttRef:(d[1]?toNttRef(d[1][1]):null), p:pNfo(d[0]) })},
    {"name": "qualified_attribute_renamed$ebnf$1$subexpression$1", "symbols": [(lexer.has("BACKSLASH") ? {type: "BACKSLASH"} : BACKSLASH), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)]},
    {"name": "qualified_attribute_renamed$ebnf$1", "symbols": ["qualified_attribute_renamed$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "qualified_attribute_renamed$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "qualified_attribute_renamed", "symbols": [(lexer.has("SELF") ? {type: "SELF"} : SELF), "qualified_attribute_renamed$ebnf$1", (lexer.has("DOT") ? {type: "DOT"} : DOT), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("RENAMED") ? {type: "RENAMED"} : RENAMED), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'qal_atr_rnmd', id:d[5].value, ref:{t:'any_ref', id:d[3].value}, nttRef:(d[1]?toNttRef(d[1][1]):null), p:pNfo(d[0]) })},
    {"name": "expression$ebnf$1$subexpression$1", "symbols": ["rel_op_extended", "simple_expression"]},
    {"name": "expression$ebnf$1", "symbols": ["expression$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "expression$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "expression", "symbols": ["simple_expression", "expression$ebnf$1"], "postprocess": d => ({t:'xpr', arg0:d[0], op:(d[1]?d[1][0]:null), arg1:(d[1]?d[1][1]:null), p:pNfo(d[0]) })},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("LE") ? {type: "LE"} : LE)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("GE") ? {type: "GE"} : GE)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("NE") ? {type: "NE"} : NE)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("SEQ") ? {type: "SEQ"} : SEQ)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("SNE") ? {type: "SNE"} : SNE)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("LT") ? {type: "LT"} : LT)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("GT") ? {type: "GT"} : GT)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("IN") ? {type: "IN"} : IN)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("LIKE") ? {type: "LIKE"} : LIKE)]},
    {"name": "rel_op_extended", "symbols": ["rel_op_extended$subexpression$1"], "postprocess": d => ({t:'o_sxp', id:toRlo(d[0][0]), p:pNfo(d[0])})},
    {"name": "simple_expression$ebnf$1", "symbols": []},
    {"name": "simple_expression$ebnf$1$subexpression$1", "symbols": ["add_like_op", "term"]},
    {"name": "simple_expression$ebnf$1", "symbols": ["simple_expression$ebnf$1", "simple_expression$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "simple_expression", "symbols": ["term", "simple_expression$ebnf$1"], "postprocess": d => toArr(d[1][0]?[d[0]].concat(...d[1]):[d[0]],'a_sxp_trms')},
    {"name": "add_like_op$subexpression$1", "symbols": [(lexer.has("PLUS") ? {type: "PLUS"} : PLUS)]},
    {"name": "add_like_op$subexpression$1", "symbols": [(lexer.has("MINUS") ? {type: "MINUS"} : MINUS)]},
    {"name": "add_like_op$subexpression$1", "symbols": [(lexer.has("OR") ? {type: "OR"} : OR)]},
    {"name": "add_like_op$subexpression$1", "symbols": [(lexer.has("XOR") ? {type: "XOR"} : XOR)]},
    {"name": "add_like_op", "symbols": ["add_like_op$subexpression$1"], "postprocess": d => ({t:'o_trm', id:toAdo(d), p:pNfo(d[0])})},
    {"name": "term$ebnf$1", "symbols": []},
    {"name": "term$ebnf$1$subexpression$1", "symbols": ["multiplication_like_op", "factor"]},
    {"name": "term$ebnf$1", "symbols": ["term$ebnf$1", "term$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "term", "symbols": ["factor", "term$ebnf$1"], "postprocess": d => toArr(d[1][0]?[d[0]].concat(...d[1]):[d[0]],'a_trm_ftrs')},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("ASTERISK") ? {type: "ASTERISK"} : ASTERISK)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("DIVIS") ? {type: "DIVIS"} : DIVIS)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("DIV") ? {type: "DIV"} : DIV)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("MOD") ? {type: "MOD"} : MOD)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("AND") ? {type: "AND"} : AND)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("DOUBLE_SOLID") ? {type: "DOUBLE_SOLID"} : DOUBLE_SOLID)]},
    {"name": "multiplication_like_op", "symbols": ["multiplication_like_op$subexpression$1"], "postprocess": d => ({t:'o_ftr', id:toMpo(d), p:pNfo(d[0])})},
    {"name": "factor$ebnf$1", "symbols": []},
    {"name": "factor$ebnf$1", "symbols": ["factor$ebnf$1", "qualifier"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "factor$ebnf$2$subexpression$1$ebnf$1", "symbols": []},
    {"name": "factor$ebnf$2$subexpression$1$ebnf$1", "symbols": ["factor$ebnf$2$subexpression$1$ebnf$1", "qualifier"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "factor$ebnf$2$subexpression$1", "symbols": [(lexer.has("DOUBLE_ASTERISTK") ? {type: "DOUBLE_ASTERISTK"} : DOUBLE_ASTERISTK), "simple_factor", "factor$ebnf$2$subexpression$1$ebnf$1"]},
    {"name": "factor$ebnf$2", "symbols": ["factor$ebnf$2$subexpression$1"], "postprocess": id},
    {"name": "factor$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "factor", "symbols": ["simple_factor", "factor$ebnf$1", "factor$ebnf$2"], "postprocess":  d => ({t:'ftr',
        	arg0:d[0][0], qals0:toArr(d[1], 'a_qals'),
        	arg1:(d[2]?d[2][1][0]:null), qals1:toArr((d[2]&&0<d[2][2].length?d[2][2]:null), 'a_qals'), p:pNfo(d[0])
        }) },
    {"name": "simple_factor", "symbols": ["literals"]},
    {"name": "simple_factor", "symbols": ["built_in_consts"]},
    {"name": "simple_factor", "symbols": ["query_expression"]},
    {"name": "simple_factor", "symbols": ["built_in_function_call"]},
    {"name": "simple_factor", "symbols": ["algorithm_call_or_entity_constructor"]},
    {"name": "simple_factor", "symbols": ["aggregate_initializer"]},
    {"name": "simple_factor", "symbols": ["interval"]},
    {"name": "simple_factor", "symbols": ["parenthesis_expr"]},
    {"name": "simple_factor", "symbols": ["unary_expr"]},
    {"name": "simple_factor", "symbols": ["any_ref"]},
    {"name": "parenthesis_expr", "symbols": [(lexer.has("LP") ? {type: "LP"} : LP), "expression", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'par', xpr:d[1], p:pNfo(d[0])})},
    {"name": "unary_op$subexpression$1", "symbols": [(lexer.has("PLUS") ? {type: "PLUS"} : PLUS)]},
    {"name": "unary_op$subexpression$1", "symbols": [(lexer.has("MINUS") ? {type: "MINUS"} : MINUS)]},
    {"name": "unary_op$subexpression$1", "symbols": [(lexer.has("NOT") ? {type: "NOT"} : NOT)]},
    {"name": "unary_op", "symbols": ["unary_op$subexpression$1"], "postprocess": d => ({t:'o_uxp', id:toUno(d), p:pNfo(d[0])})},
    {"name": "unary_expr", "symbols": ["unary_op", "simple_factor"], "postprocess": d => ({t:'uxp', op:d[0], arg:d[1][0], p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("REAL_LIT") ? {type: "REAL_LIT"} : REAL_LIT)], "postprocess": d => ({t:'rea', val:parseFloat(d[0].value), p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("INT") ? {type: "INT"} : INT)], "postprocess": d => ({t:'int', val:parseInt(d[0].value), p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("STR") ? {type: "STR"} : STR)], "postprocess": d => ({t:'str', val:convStr(d[0].value), p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("ENCSTR") ? {type: "ENCSTR"} : ENCSTR)], "postprocess": d => ({t:'enc', val:convStr(d[0].value), p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("BIN") ? {type: "BIN"} : BIN)], "postprocess": d => ({t:'bin', val:d[0].value, p:pNfo(d[0])})},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("CONST_E") ? {type: "CONST_E"} : CONST_E)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("PI") ? {type: "PI"} : PI)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("SELF") ? {type: "SELF"} : SELF)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("INDET") ? {type: "INDET"} : INDET)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("TRUE") ? {type: "TRUE"} : TRUE)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("FALSE") ? {type: "FALSE"} : FALSE)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("UNKNOWN") ? {type: "UNKNOWN"} : UNKNOWN)]},
    {"name": "built_in_consts", "symbols": ["built_in_consts$subexpression$1"], "postprocess": d => ({t:'bic', id:toBic(d), p:pNfo(d[0])})},
    {"name": "any_ref", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'any_ref', id:d[0].value, p:pNfo(d[0])})},
    {"name": "qualifier", "symbols": [(lexer.has("DOT") ? {type: "DOT"} : DOT), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'any_ref', id:d[1].value, p:pNfo(d[0])})},
    {"name": "qualifier", "symbols": [(lexer.has("BACKSLASH") ? {type: "BACKSLASH"} : BACKSLASH), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'ntt_ref', id:d[1].value, p:pNfo(d[0])})},
    {"name": "qualifier$ebnf$1$subexpression$1", "symbols": [(lexer.has("COLON") ? {type: "COLON"} : COLON), "simple_expression"]},
    {"name": "qualifier$ebnf$1", "symbols": ["qualifier$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "qualifier$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "qualifier", "symbols": [(lexer.has("LB") ? {type: "LB"} : LB), "simple_expression", "qualifier$ebnf$1", (lexer.has("RB") ? {type: "RB"} : RB)], "postprocess": d => ({t:'idx_qal', fr:d[1], to:(d[2]?d[2]:null), p:pNfo(d[0]) })},
    {"name": "interval$subexpression$1", "symbols": [(lexer.has("LT") ? {type: "LT"} : LT)]},
    {"name": "interval$subexpression$1", "symbols": [(lexer.has("LE") ? {type: "LE"} : LE)]},
    {"name": "interval$subexpression$2", "symbols": [(lexer.has("LT") ? {type: "LT"} : LT)]},
    {"name": "interval$subexpression$2", "symbols": [(lexer.has("LE") ? {type: "LE"} : LE)]},
    {"name": "interval", "symbols": [(lexer.has("LC") ? {type: "LC"} : LC), "simple_expression", "interval$subexpression$1", "simple_expression", "interval$subexpression$2", "simple_expression", (lexer.has("RC") ? {type: "RC"} : RC)], "postprocess":  d => ({t:'itv',
        	arg0:d[1],
        	id1:toRlo(d[2][0]), arg1:d[3],
        	id2:toRlo(d[4][0]), arg2:d[5], p:pNfo(d[0])
        }) },
    {"name": "query_expression", "symbols": [(lexer.has("QUERY") ? {type: "QUERY"} : QUERY), (lexer.has("LP") ? {type: "LP"} : LP), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("LESS_ASTERISK") ? {type: "LESS_ASTERISK"} : LESS_ASTERISK), "simple_expression", (lexer.has("SOLID") ? {type: "SOLID"} : SOLID), "expression", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'qry', var:d[2].value, src:d[4], cnd:d[6], p:pNfo(d[0]) })},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ABS") ? {type: "ABS"} : ABS)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ACOS") ? {type: "ACOS"} : ACOS)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ASIN") ? {type: "ASIN"} : ASIN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ATAN") ? {type: "ATAN"} : ATAN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("BLENGTH") ? {type: "BLENGTH"} : BLENGTH)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("COS") ? {type: "COS"} : COS)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("EXISTS") ? {type: "EXISTS"} : EXISTS)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("EXP") ? {type: "EXP"} : EXP)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("FORMAT") ? {type: "FORMAT"} : FORMAT)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("HIBOUND") ? {type: "HIBOUND"} : HIBOUND)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("HIINDEX") ? {type: "HIINDEX"} : HIINDEX)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LENGTH") ? {type: "LENGTH"} : LENGTH)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOBOUND") ? {type: "LOBOUND"} : LOBOUND)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOINDEX") ? {type: "LOINDEX"} : LOINDEX)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOG") ? {type: "LOG"} : LOG)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOG2") ? {type: "LOG2"} : LOG2)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOG10") ? {type: "LOG10"} : LOG10)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("NVL") ? {type: "NVL"} : NVL)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ODD") ? {type: "ODD"} : ODD)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ROLESOF") ? {type: "ROLESOF"} : ROLESOF)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("SIN") ? {type: "SIN"} : SIN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("SIZEOF") ? {type: "SIZEOF"} : SIZEOF)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("SQRT") ? {type: "SQRT"} : SQRT)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("TAN") ? {type: "TAN"} : TAN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("TYPEOF") ? {type: "TYPEOF"} : TYPEOF)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("USEDIN") ? {type: "USEDIN"} : USEDIN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("VALUE") ? {type: "VALUE"} : VALUE)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("VALUE_IN") ? {type: "VALUE_IN"} : VALUE_IN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("VALUE_UNIQUE") ? {type: "VALUE_UNIQUE"} : VALUE_UNIQUE)]},
    {"name": "built_in_function_call", "symbols": ["built_in_function_call$subexpression$1", (lexer.has("LP") ? {type: "LP"} : LP), "expr_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'bif', id:toBif(d), vals:toArr(d[2],'a_bif_vals'), p:pNfo(d[0])})},
    {"name": "algorithm_call_or_entity_constructor$ebnf$1", "symbols": ["expr_list"], "postprocess": id},
    {"name": "algorithm_call_or_entity_constructor$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "algorithm_call_or_entity_constructor", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("LP") ? {type: "LP"} : LP), "algorithm_call_or_entity_constructor$ebnf$1", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'coc', ref:{t:'any_ref', id:d[0].value}, vals:toArr(d[2],'a_coc_vals'), p:pNfo(d[0])})},
    {"name": "expr_list$ebnf$1", "symbols": []},
    {"name": "expr_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "expression"]},
    {"name": "expr_list$ebnf$1", "symbols": ["expr_list$ebnf$1", "expr_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "expr_list", "symbols": ["expression", "expr_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "aggregate_initializer$ebnf$1", "symbols": ["elem_list"], "postprocess": id},
    {"name": "aggregate_initializer$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "aggregate_initializer", "symbols": [(lexer.has("LB") ? {type: "LB"} : LB), "aggregate_initializer$ebnf$1", (lexer.has("RB") ? {type: "RB"} : RB)], "postprocess": d => ({t:'agi', vals:toArr(d[1],'a_agi_elts'), p:pNfo(d[0])})},
    {"name": "elem_list$ebnf$1", "symbols": []},
    {"name": "elem_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "element"]},
    {"name": "elem_list$ebnf$1", "symbols": ["elem_list$ebnf$1", "elem_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "elem_list", "symbols": ["element", "elem_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "element$ebnf$1$subexpression$1", "symbols": [(lexer.has("COLON") ? {type: "COLON"} : COLON), "simple_expression"]},
    {"name": "element$ebnf$1", "symbols": ["element$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "element$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "element", "symbols": ["expression", "element$ebnf$1"], "postprocess": d => ({t:'elt', arg:d[0], mlt:(d[1]?d[1][1]:null), p:pNfo(d[0]) })},
    {"name": "where_clause$ebnf$1", "symbols": ["where_condition"]},
    {"name": "where_clause$ebnf$1", "symbols": ["where_clause$ebnf$1", "where_condition"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "where_clause", "symbols": [(lexer.has("WHERE") ? {type: "WHERE"} : WHERE), "where_clause$ebnf$1"], "postprocess": d => d[1]},
    {"name": "where_condition", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("COLON") ? {type: "COLON"} : COLON), "expression", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'whr', id:d[0].value, xpr:d[2], p:pNfo(d[0])})},
    {"name": "unique_clause$ebnf$1", "symbols": ["unique_condition"]},
    {"name": "unique_clause$ebnf$1", "symbols": ["unique_clause$ebnf$1", "unique_condition"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "unique_clause", "symbols": [(lexer.has("UNIQUE") ? {type: "UNIQUE"} : UNIQUE), "unique_clause$ebnf$1"], "postprocess": d => d[1]},
    {"name": "unique_condition", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("COLON") ? {type: "COLON"} : COLON), "attr_list", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'unq', id:d[0].value, args:toArr(d[2],'a_unq_args'), p:pNfo(d[0])})},
    {"name": "p_formal_params", "symbols": [(lexer.has("LP") ? {type: "LP"} : LP), "p_typed_params_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => d[1]},
    {"name": "p_typed_params_list$ebnf$1", "symbols": []},
    {"name": "p_typed_params_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "p_typed_params"]},
    {"name": "p_typed_params_list$ebnf$1", "symbols": ["p_typed_params_list$ebnf$1", "p_typed_params_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "p_typed_params_list", "symbols": ["p_typed_params", "p_typed_params_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "p_typed_params$ebnf$1", "symbols": [(lexer.has("VAR") ? {type: "VAR"} : VAR)], "postprocess": id},
    {"name": "p_typed_params$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "p_typed_params", "symbols": ["p_typed_params$ebnf$1", "param_id_list", (lexer.has("COLON") ? {type: "COLON"} : COLON), "parameter_type"], "postprocess": d => ({t:'prm_dcl', var:d[0]?true:false, ids:toArr(d[1],'a_prm_ids'), typ:d[3], p:pNfo(d[1])})},
    {"name": "formal_params", "symbols": [(lexer.has("LP") ? {type: "LP"} : LP), "typed_params_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => d[1]},
    {"name": "typed_params_list$ebnf$1", "symbols": []},
    {"name": "typed_params_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "typed_params"]},
    {"name": "typed_params_list$ebnf$1", "symbols": ["typed_params_list$ebnf$1", "typed_params_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "typed_params_list", "symbols": ["typed_params", "typed_params_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "typed_params", "symbols": ["param_id_list", (lexer.has("COLON") ? {type: "COLON"} : COLON), "parameter_type"], "postprocess": d => ({t:'prm_dcl', ids:toArr(d[0],'a_prm_ids'), typ:d[2], p:pNfo(d[0])})},
    {"name": "param_id", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'prm', id:d[0].value, p:pNfo(d[0])})},
    {"name": "param_id_list$ebnf$1", "symbols": []},
    {"name": "param_id_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "param_id"]},
    {"name": "param_id_list$ebnf$1", "symbols": ["param_id_list$ebnf$1", "param_id_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "param_id_list", "symbols": ["param_id", "param_id_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "subtype_constraint_decl", "symbols": [(lexer.has("SUBTYPE_CONSTRAINT") ? {type: "SUBTYPE_CONSTRAINT"} : SUBTYPE_CONSTRAINT), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("FOR") ? {type: "FOR"} : FOR), "entity_ref", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "subtype_constraint_body", (lexer.has("END_SUBTYPE_CONSTRAINT") ? {type: "END_SUBTYPE_CONSTRAINT"} : END_SUBTYPE_CONSTRAINT), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'sct_dcl', id:d[1].value,
        	nttRef:d[3], abs:d[5].abs, ttlNttRefs:d[5].ttlNttRefs,
        	cnd:(Array.isArray(d[5].cnd)?d[5].cnd[0]:null), p:pNfo(d[0])
        }) },
    {"name": "subtype_constraint_body$ebnf$1$subexpression$1", "symbols": [(lexer.has("ABSTRACT") ? {type: "ABSTRACT"} : ABSTRACT), (lexer.has("SUPERTYPE") ? {type: "SUPERTYPE"} : SUPERTYPE), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)]},
    {"name": "subtype_constraint_body$ebnf$1", "symbols": ["subtype_constraint_body$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "subtype_constraint_body$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "subtype_constraint_body$ebnf$2", "symbols": ["total_over"], "postprocess": id},
    {"name": "subtype_constraint_body$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "subtype_constraint_body$ebnf$3$subexpression$1", "symbols": ["supertype_expression", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)]},
    {"name": "subtype_constraint_body$ebnf$3", "symbols": ["subtype_constraint_body$ebnf$3$subexpression$1"], "postprocess": id},
    {"name": "subtype_constraint_body$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "subtype_constraint_body", "symbols": ["subtype_constraint_body$ebnf$1", "subtype_constraint_body$ebnf$2", "subtype_constraint_body$ebnf$3"], "postprocess": d => ({abs:(d[0]?true:false), ttlNttRefs:toArr(d[1],'a_ttl_refs'), cnd:(d[2]?d[2]:null) })},
    {"name": "total_over", "symbols": [(lexer.has("TOTAL_OVER") ? {type: "TOTAL_OVER"} : TOTAL_OVER), (lexer.has("LP") ? {type: "LP"} : LP), "entity_ref_list", (lexer.has("RP") ? {type: "RP"} : RP), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => d[2]},
    {"name": "entity_decl$ebnf$1", "symbols": [(lexer.has("ABSTRACT") ? {type: "ABSTRACT"} : ABSTRACT)], "postprocess": id},
    {"name": "entity_decl$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "entity_decl$ebnf$2", "symbols": ["supertype_constraint"], "postprocess": id},
    {"name": "entity_decl$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "entity_decl$ebnf$3", "symbols": ["subtype_declaration"], "postprocess": id},
    {"name": "entity_decl$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "entity_decl", "symbols": [(lexer.has("ENTITY") ? {type: "ENTITY"} : ENTITY), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), "entity_decl$ebnf$1", "entity_decl$ebnf$2", "entity_decl$ebnf$3", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "entity_body", (lexer.has("END_ENTITY") ? {type: "END_ENTITY"} : END_ENTITY), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'ntt', id:d[1].value, abs:!!d[2],
        	cnd:(d[3]?d[3]:null), sprs:toArr(d[4],'a_spr_refs'),
        	atrs:d[6].atrs, drvs:d[6].drvs,
        	whrs:d[6].whrs, unqs:d[6].unqs,
        	invs:d[6].invs, p:pNfo(d[0])
        }) },
    {"name": "supertype_constraint", "symbols": [(lexer.has("SUPERTYPE") ? {type: "SUPERTYPE"} : SUPERTYPE), (lexer.has("OF") ? {type: "OF"} : OF), (lexer.has("LP") ? {type: "LP"} : LP), "supertype_expression", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => d[3]},
    {"name": "supertype_constraint", "symbols": [(lexer.has("SUPERTYPE") ? {type: "SUPERTYPE"} : SUPERTYPE)], "postprocess": d => null},
    {"name": "supertype_expression$ebnf$1", "symbols": []},
    {"name": "supertype_expression$ebnf$1$subexpression$1", "symbols": [(lexer.has("ANDOR") ? {type: "ANDOR"} : ANDOR), "supertype_factor"]},
    {"name": "supertype_expression$ebnf$1", "symbols": ["supertype_expression$ebnf$1", "supertype_expression$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "supertype_expression", "symbols": ["supertype_factor", "supertype_expression$ebnf$1"], "postprocess": d => toArr((d[1][0]?[d[0]].concat(...d[1]):[d[0]]).filter(elt => elt.t == 'a_spf_spts'),'a_spx_spfs')},
    {"name": "supertype_factor$ebnf$1", "symbols": []},
    {"name": "supertype_factor$ebnf$1$subexpression$1", "symbols": [(lexer.has("AND") ? {type: "AND"} : AND), "supertype_term"]},
    {"name": "supertype_factor$ebnf$1", "symbols": ["supertype_factor$ebnf$1", "supertype_factor$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "supertype_factor", "symbols": ["supertype_term", "supertype_factor$ebnf$1"], "postprocess": d => toArr((d[1][0]?[d[0]].concat(...d[1]):[d[0]]).filter(elt => (['ntt_ref', 'a_oof_spxs', 'a_spx_spfs'].includes(elt.t))),'a_spf_spts')},
    {"name": "supertype_term", "symbols": ["entity_ref"], "postprocess": d => d[0]},
    {"name": "supertype_term", "symbols": ["one_of"], "postprocess": d => d[0]},
    {"name": "supertype_term", "symbols": [(lexer.has("LP") ? {type: "LP"} : LP), "supertype_expression", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => d[1]},
    {"name": "one_of", "symbols": [(lexer.has("ONEOF") ? {type: "ONEOF"} : ONEOF), (lexer.has("LP") ? {type: "LP"} : LP), "subtype_expr_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => toArr(d[2],'a_oof_spxs')},
    {"name": "subtype_expr_list$ebnf$1", "symbols": []},
    {"name": "subtype_expr_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "supertype_expression"]},
    {"name": "subtype_expr_list$ebnf$1", "symbols": ["subtype_expr_list$ebnf$1", "subtype_expr_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "subtype_expr_list", "symbols": ["supertype_expression", "subtype_expr_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "subtype_declaration", "symbols": [(lexer.has("SUBTYPE") ? {type: "SUBTYPE"} : SUBTYPE), (lexer.has("OF") ? {type: "OF"} : OF), (lexer.has("LP") ? {type: "LP"} : LP), "entity_ref_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => d[3]},
    {"name": "entity_ref_list$ebnf$1", "symbols": []},
    {"name": "entity_ref_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "entity_ref"]},
    {"name": "entity_ref_list$ebnf$1", "symbols": ["entity_ref_list$ebnf$1", "entity_ref_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "entity_ref_list", "symbols": ["entity_ref", "entity_ref_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "entity_ref", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => toNttRef(d[0])},
    {"name": "entity_body$ebnf$1", "symbols": ["derive"], "postprocess": id},
    {"name": "entity_body$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "entity_body$ebnf$2", "symbols": ["inverse"], "postprocess": id},
    {"name": "entity_body$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "entity_body$ebnf$3", "symbols": ["unique_clause"], "postprocess": id},
    {"name": "entity_body$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "entity_body$ebnf$4", "symbols": ["where_clause"], "postprocess": id},
    {"name": "entity_body$ebnf$4", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "entity_body", "symbols": ["attrs", "entity_body$ebnf$1", "entity_body$ebnf$2", "entity_body$ebnf$3", "entity_body$ebnf$4"], "postprocess":  d => ({
        	atrs:toArr(d[0],'a_ntt_atrs'),
        	drvs:toArr(d[1],'a_ntt_drvs'),
        	whrs:toArr(d[4],'a_ntt_whrs'),
        	unqs:toArr(d[3],'a_ntt_unqs'),
        	invs:toArr(d[2],'a_ntt_invs'), p:pNfo(d[0])
        }) },
    {"name": "attrs$ebnf$1", "symbols": []},
    {"name": "attrs$ebnf$1", "symbols": ["attrs$ebnf$1", "explicit_attr"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "attrs", "symbols": ["attrs$ebnf$1"], "postprocess": d => d[0]},
    {"name": "derive$ebnf$1", "symbols": ["derived_attr"]},
    {"name": "derive$ebnf$1", "symbols": ["derive$ebnf$1", "derived_attr"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "derive", "symbols": [(lexer.has("DERIVE") ? {type: "DERIVE"} : DERIVE), "derive$ebnf$1"], "postprocess": d => d[1]},
    {"name": "inverse$ebnf$1", "symbols": ["inverse_attr"]},
    {"name": "inverse$ebnf$1", "symbols": ["inverse$ebnf$1", "inverse_attr"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "inverse", "symbols": [(lexer.has("INVERSE") ? {type: "INVERSE"} : INVERSE), "inverse$ebnf$1"], "postprocess": d => d[1]},
    {"name": "use_clause", "symbols": [(lexer.has("USE") ? {type: "USE"} : USE), (lexer.has("FROM") ? {type: "FROM"} : FROM), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("LP") ? {type: "LP"} : LP), "uor_ref_list", (lexer.has("RP") ? {type: "RP"} : RP), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'use', id:d[2].value, refs:toArr(d[4],'a_use_refs'), p:pNfo(d[0]) })},
    {"name": "reference_clause", "symbols": [(lexer.has("REFERENCE") ? {type: "REFERENCE"} : REFERENCE), (lexer.has("FROM") ? {type: "FROM"} : FROM), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("LP") ? {type: "LP"} : LP), "uor_ref_list", (lexer.has("RP") ? {type: "RP"} : RP), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'ref', id:d[2].value, refs:toArr(d[4],'a_ref_refs'), p:pNfo(d[0]) })},
    {"name": "uor_ref_list$ebnf$1", "symbols": []},
    {"name": "uor_ref_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "uor_ref"]},
    {"name": "uor_ref_list$ebnf$1", "symbols": ["uor_ref_list$ebnf$1", "uor_ref_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "uor_ref_list", "symbols": ["uor_ref", "uor_ref_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "uor_ref", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("AS") ? {type: "AS"} : AS), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'ref_rnmd', id:d[2].value, ref:{t:'any_ref', id:d[0].value, p:pNfo(d[0])}, p:pNfo(d[0])})},
    {"name": "uor_ref", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'any_ref', id:d[0].value, p:pNfo(d[0])})},
    {"name": "interface_specification", "symbols": ["reference_clause"], "postprocess": d => d[0]},
    {"name": "interface_specification", "symbols": ["use_clause"], "postprocess": d => d[0]},
    {"name": "constant_body", "symbols": ["constant_id", (lexer.has("COLON") ? {type: "COLON"} : COLON), "parameter_type", (lexer.has("ASSIGN") ? {type: "ASSIGN"} : ASSIGN), "expression", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'cst_dcl', id:d[0], typ:d[2], xpr:d[4], p:pNfo(d[0])})},
    {"name": "constant_id", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'cst', id:d[0].value, p:pNfo(d[0])})},
    {"name": "constant_decl$ebnf$1", "symbols": ["constant_body"]},
    {"name": "constant_decl$ebnf$1", "symbols": ["constant_decl$ebnf$1", "constant_body"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "constant_decl", "symbols": [(lexer.has("CONSTANT") ? {type: "CONSTANT"} : CONSTANT), "constant_decl$ebnf$1", (lexer.has("END_CONSTANT") ? {type: "END_CONSTANT"} : END_CONSTANT), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => d[1]},
    {"name": "alias_stmt$ebnf$1", "symbols": []},
    {"name": "alias_stmt$ebnf$1", "symbols": ["alias_stmt$ebnf$1", "qualifier"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "alias_stmt$ebnf$2", "symbols": ["stmt"]},
    {"name": "alias_stmt$ebnf$2", "symbols": ["alias_stmt$ebnf$2", "stmt"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "alias_stmt", "symbols": [(lexer.has("ALIAS") ? {type: "ALIAS"} : ALIAS), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("FOR") ? {type: "FOR"} : FOR), "any_ref", "alias_stmt$ebnf$1", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "alias_stmt$ebnf$2", (lexer.has("END_ALIAS") ? {type: "END_ALIAS"} : END_ALIAS), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'als',
        	var:d[1].value,
        	ref:d[3], qals:toArr(d[4], 'a_qals'),
        	stms:toArr(d[6], 'a_stms'),
        	p:pNfo(d[0])
        }) },
    {"name": "assignment_stmt$ebnf$1", "symbols": []},
    {"name": "assignment_stmt$ebnf$1", "symbols": ["assignment_stmt$ebnf$1", "qualifier"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "assignment_stmt", "symbols": ["any_ref", "assignment_stmt$ebnf$1", (lexer.has("ASSIGN") ? {type: "ASSIGN"} : ASSIGN), "expression", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'asg',
        	ref:d[0], qals:toArr(d[1], 'a_qals'),
        	xpr:d[3], p:pNfo(d[2])
        }) },
    {"name": "case_stmt$ebnf$1", "symbols": []},
    {"name": "case_stmt$ebnf$1", "symbols": ["case_stmt$ebnf$1", "case_action"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "case_stmt$ebnf$2$subexpression$1", "symbols": [(lexer.has("OTHERWISE") ? {type: "OTHERWISE"} : OTHERWISE), (lexer.has("COLON") ? {type: "COLON"} : COLON), "stmt"]},
    {"name": "case_stmt$ebnf$2", "symbols": ["case_stmt$ebnf$2$subexpression$1"], "postprocess": id},
    {"name": "case_stmt$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "case_stmt", "symbols": [(lexer.has("CASE") ? {type: "CASE"} : CASE), "expression", (lexer.has("OF") ? {type: "OF"} : OF), "case_stmt$ebnf$1", "case_stmt$ebnf$2", (lexer.has("END_CASE") ? {type: "END_CASE"} : END_CASE), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'cas',
        	slr: d[1],
        	caas:toArr(d[3], 'a_caas'),
        	oth: (d[4]?d[4][2]:null),
        	p:pNfo(d[0])
        }) },
    {"name": "case_action", "symbols": ["case_should_list", (lexer.has("COLON") ? {type: "COLON"} : COLON), "stmt"], "postprocess":  d => ({t:'caa',
        	xprs:toArr(d[0], 'a_xprs'),
        	stm: d[2],
        	p:pNfo(d[1])
        }) },
    {"name": "case_should_list$ebnf$1", "symbols": []},
    {"name": "case_should_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "expression"]},
    {"name": "case_should_list$ebnf$1", "symbols": ["case_should_list$ebnf$1", "case_should_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "case_should_list", "symbols": ["expression", "case_should_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "compound_stmt$ebnf$1", "symbols": ["stmt"]},
    {"name": "compound_stmt$ebnf$1", "symbols": ["compound_stmt$ebnf$1", "stmt"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "compound_stmt", "symbols": [(lexer.has("BEGIN") ? {type: "BEGIN"} : BEGIN), "compound_stmt$ebnf$1", (lexer.has("END") ? {type: "END"} : END), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'cpd',
        	stms:toArr(d[1], 'a_stms'),
        	p:pNfo(d[0])
        }) },
    {"name": "escape_stmt", "symbols": [(lexer.has("ESCAPE") ? {type: "ESCAPE"} : ESCAPE), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'esc', p:pNfo(d[0]) })},
    {"name": "if_stmt$ebnf$1", "symbols": ["stmt"]},
    {"name": "if_stmt$ebnf$1", "symbols": ["if_stmt$ebnf$1", "stmt"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "if_stmt$ebnf$2$subexpression$1$ebnf$1", "symbols": ["stmt"]},
    {"name": "if_stmt$ebnf$2$subexpression$1$ebnf$1", "symbols": ["if_stmt$ebnf$2$subexpression$1$ebnf$1", "stmt"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "if_stmt$ebnf$2$subexpression$1", "symbols": [(lexer.has("ELSE") ? {type: "ELSE"} : ELSE), "if_stmt$ebnf$2$subexpression$1$ebnf$1"]},
    {"name": "if_stmt$ebnf$2", "symbols": ["if_stmt$ebnf$2$subexpression$1"], "postprocess": id},
    {"name": "if_stmt$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "if_stmt", "symbols": [(lexer.has("IF") ? {type: "IF"} : IF), "expression", (lexer.has("THEN") ? {type: "THEN"} : THEN), "if_stmt$ebnf$1", "if_stmt$ebnf$2", (lexer.has("END_IF") ? {type: "END_IF"} : END_IF), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'iff',
        	cnd:d[1],
        	stms:toArr(d[3], 'a_stms'),
        	elss:(d[4]?toArr(d[4][1], 'a_stms'):null),
        	p:pNfo(d[0])
        }) },
    {"name": "built_in_procedure_call$subexpression$1", "symbols": [(lexer.has("INSERT") ? {type: "INSERT"} : INSERT)]},
    {"name": "built_in_procedure_call$subexpression$1", "symbols": [(lexer.has("REMOVE") ? {type: "REMOVE"} : REMOVE)]},
    {"name": "built_in_procedure_call", "symbols": ["built_in_procedure_call$subexpression$1", (lexer.has("LP") ? {type: "LP"} : LP), "expr_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'bip', id:toBip(d), vals:toArr(d[2],'a_bip_vals'), p:pNfo(d[0])})},
    {"name": "procedure_call_stmt$subexpression$1", "symbols": ["built_in_procedure_call"]},
    {"name": "procedure_call_stmt$subexpression$1", "symbols": ["algorithm_call_or_entity_constructor"]},
    {"name": "procedure_call_stmt", "symbols": ["procedure_call_stmt$subexpression$1", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => d[0]},
    {"name": "repeat_stmt$ebnf$1$subexpression$1$ebnf$1$subexpression$1", "symbols": [(lexer.has("BY") ? {type: "BY"} : BY), "simple_expression"]},
    {"name": "repeat_stmt$ebnf$1$subexpression$1$ebnf$1", "symbols": ["repeat_stmt$ebnf$1$subexpression$1$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "repeat_stmt$ebnf$1$subexpression$1$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "repeat_stmt$ebnf$1$subexpression$1", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("ASSIGN") ? {type: "ASSIGN"} : ASSIGN), "simple_expression", (lexer.has("TO") ? {type: "TO"} : TO), "simple_expression", "repeat_stmt$ebnf$1$subexpression$1$ebnf$1"]},
    {"name": "repeat_stmt$ebnf$1", "symbols": ["repeat_stmt$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "repeat_stmt$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "repeat_stmt$ebnf$2$subexpression$1", "symbols": [(lexer.has("WHILE") ? {type: "WHILE"} : WHILE), "expression"]},
    {"name": "repeat_stmt$ebnf$2", "symbols": ["repeat_stmt$ebnf$2$subexpression$1"], "postprocess": id},
    {"name": "repeat_stmt$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "repeat_stmt$ebnf$3$subexpression$1", "symbols": [(lexer.has("UNTIL") ? {type: "UNTIL"} : UNTIL), "expression"]},
    {"name": "repeat_stmt$ebnf$3", "symbols": ["repeat_stmt$ebnf$3$subexpression$1"], "postprocess": id},
    {"name": "repeat_stmt$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "repeat_stmt$ebnf$4", "symbols": ["stmt"]},
    {"name": "repeat_stmt$ebnf$4", "symbols": ["repeat_stmt$ebnf$4", "stmt"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "repeat_stmt", "symbols": [(lexer.has("REPEAT") ? {type: "REPEAT"} : REPEAT), "repeat_stmt$ebnf$1", "repeat_stmt$ebnf$2", "repeat_stmt$ebnf$3", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "repeat_stmt$ebnf$4", (lexer.has("END_REPEAT") ? {type: "END_REPEAT"} : END_REPEAT), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'rpt',
        	var:(d[1]?d[1][0].value:null),
        	itr:(d[1]?toBds( {t:'itr', fr:d[1][2], to:d[1][4], by:(d[1][5]?d[1][5][1]:null), p:pNfo(d[1][1])} ):null),
        	whl:(d[2]?d[2][1]:null),
        	utl:(d[3]?d[3][1]:null),
        	stms:toArr(d[5], 'a_stms'),
        	p:pNfo(d[0])
        }) },
    {"name": "null_stmt", "symbols": [(lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'nul', p:pNfo(d[0]) })},
    {"name": "return_stmt$ebnf$1", "symbols": ["expression"], "postprocess": id},
    {"name": "return_stmt$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "return_stmt", "symbols": [(lexer.has("RETURN") ? {type: "RETURN"} : RETURN), "return_stmt$ebnf$1", (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'ret',
        	xpr:(d[1]?d[1]:null), p:pNfo(d[0])
        }) },
    {"name": "skip_stmt", "symbols": [(lexer.has("SKIP") ? {type: "SKIP"} : SKIP), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess": d => ({t:'skp', p:pNfo(d[0]) })},
    {"name": "stmt$subexpression$1", "symbols": ["alias_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["assignment_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["case_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["compound_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["escape_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["if_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["procedure_call_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["repeat_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["null_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["return_stmt"]},
    {"name": "stmt$subexpression$1", "symbols": ["skip_stmt"]},
    {"name": "stmt", "symbols": ["stmt$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "schema_declaration$subexpression$1", "symbols": ["type_decl"]},
    {"name": "schema_declaration$subexpression$1", "symbols": ["entity_decl"]},
    {"name": "schema_declaration$subexpression$1", "symbols": ["subtype_constraint_decl"]},
    {"name": "schema_declaration$subexpression$1", "symbols": ["function_decl"]},
    {"name": "schema_declaration$subexpression$1", "symbols": ["procedure_decl"]},
    {"name": "schema_declaration$subexpression$1", "symbols": ["rule_decl"]},
    {"name": "schema_declaration", "symbols": ["schema_declaration$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "schema_body$ebnf$1", "symbols": []},
    {"name": "schema_body$ebnf$1", "symbols": ["schema_body$ebnf$1", "schema_declaration"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "schema_body", "symbols": ["schema_body$ebnf$1"], "postprocess": d => d[0]},
    {"name": "schema_decl$ebnf$1", "symbols": []},
    {"name": "schema_decl$ebnf$1", "symbols": ["schema_decl$ebnf$1", "interface_specification"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "schema_decl$ebnf$2", "symbols": ["constant_decl"], "postprocess": id},
    {"name": "schema_decl$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "schema_decl", "symbols": [(lexer.has("SCHEMA") ? {type: "SCHEMA"} : SCHEMA), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI), "schema_decl$ebnf$1", "schema_decl$ebnf$2", "schema_body", (lexer.has("END_SCHEMA") ? {type: "END_SCHEMA"} : END_SCHEMA), (lexer.has("SEMI") ? {type: "SEMI"} : SEMI)], "postprocess":  d => ({t:'scm', id:d[1].value,
        	refs:toArr(d[3],'a_scm_refs'),
        	csts:toArr(d[4],'a_scm_csts'),
        	scts:toArr(d[5],'a_scm_scts'), p:pNfo(d[0])
        }) },
    {"name": "syntax$ebnf$1", "symbols": ["schema_decl"]},
    {"name": "syntax$ebnf$1", "symbols": ["syntax$ebnf$1", "schema_decl"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "syntax", "symbols": ["syntax$ebnf$1"], "postprocess": d => d[0]}
];
let ParserStart = "main";
export default { Lexer, ParserRules, ParserStart };
